import React from 'react';
import { connect } from 'react-redux';
import { LoanInfoConstants } from './../../constants';
import InputLabel from './InputLabel/InputLabel';
import DropDown from './DropDown/DropDown';
import CurrencyInput from './CurrencyInput/CurrencyInput';
import "./loanCustomerInformation.scss";
import { fetchActiveLoans, saveCustomerInformation, fetchExternalAccounts } from "../../actions/crossSellApplicationActions";
import { getOfferPreFilledData } from "../../selectors";
import { isMobileNativeApp } from '../../utils/mobileAppCheck';
import { getHeaderStatus } from "../../utils/is.after";
import { updateStandardDataLayerAttributes, setCustomDataLayer } from "../../analytics/adobe/index";
import { loanCustomerInfoDataLayer } from "../../analytics/adobe/dataLayerValues";
import moneyFormatter from 'money-formatter';

export class LoanCustomerInformation extends React.Component {

  constructor(props) {
    super(props);
    this.state= {
      annualIncomeVal: 0,
      sourceOfIncomeVal: '',
      residenceStatusVal: '',
      housingPaymentVal: 0,
      isButtonDisabled: true,
      isHousingPaymentShow: false,
      loanPurpose: '',
      selectedLoanPurpose: '',
      loanAmountVal: '',
      loanAmountErrorMessage: ' ',
      displayMinAmount: '',
      displayMaxAmount: ''
    };
    this.handleButtonDisable = this.handleButtonDisable.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleContinueClick = this.handleContinueClick.bind(this);
  }

  async componentDidMount() {
    const { pageName, siteSection, marketCode }=loanCustomerInfoDataLayer;
    updateStandardDataLayerAttributes(setCustomDataLayer(pageName, siteSection, marketCode), false);
    const desiredLoanAmount = document.getElementById('desired-loan-amount');
    if(desiredLoanAmount) {
      desiredLoanAmount.focus();
    }
    await this.props.fetchActiveLoans();
    this.props.fetchExternalAccounts();
  }

  componentWillMount() {
    const cust= this.props.customerInformation.customerInformation;
    let incomeValue=cust.grossAnnualIncomeInfo;
    if(cust.residenceStatusInfo === "Rent" || cust.residenceStatusInfo === "Other"){
      this.setState({
        isHousingPaymentShow: true,
        annualIncomeVal: new Intl.NumberFormat().format(cust.grossAnnualIncomeInfo),
        housingPaymentVal: new Intl.NumberFormat().format(cust.housingPaymentInfo),
        sourceOfIncomeVal: cust.sourceOfIncomeInfo,
        residenceStatusVal: cust.residenceStatusInfo,
        isButtonDisabled: false,
        loanPurpose: cust.loanPurposeInfo,
        selectedLoanPurpose: LoanInfoConstants.fields.crossSellLoanPurpose.options[LoanInfoConstants.fields.crossSellLoanPurpose.values.indexOf(cust.loanPurposeInfo)],
        loanAmountVal: cust.loanAmountInfo,
        displayMinAmount: this.props.customerInformation.displayMinAmount,
        displayMaxAmount: this.props.customerInformation.displayMaxAmount
      });
    } else {
      if(cust.grossAnnualIncomeInfo) {
        incomeValue = new Intl.NumberFormat().format(cust.grossAnnualIncomeInfo);
      }
      this.setState({
        annualIncomeVal: incomeValue,
        housingPaymentVal: cust.housingPaymentInfo,
        sourceOfIncomeVal: cust.sourceOfIncomeInfo,
        residenceStatusVal: cust.residenceStatusInfo,
        loanPurpose: cust.loanPurposeInfo,
        selectedLoanPurpose: LoanInfoConstants.fields.crossSellLoanPurpose.options[LoanInfoConstants.fields.crossSellLoanPurpose.values.indexOf(cust.loanPurposeInfo)],
        loanAmountVal: cust.loanAmountInfo,
        displayMinAmount: this.props.customerInformation.displayMinAmount,
        displayMaxAmount: this.props.customerInformation.displayMaxAmount
      }, this.handleButtonDisable);
    }
  }

  handleButtonDisable() {
    const { annualIncomeVal, sourceOfIncomeVal, residenceStatusVal, housingPaymentVal, loanAmountVal, loanPurpose }=this.state;
    this.annualIncomeVal = annualIncomeVal.toString().replace(/,/g, "").replace(/\$/g, "");
    this.housingPaymentVal = housingPaymentVal.toString().replace(/,/g, "").replace(/\$/g, "");
    this.loanAmountVal = loanAmountVal.toString().replace(/,/g, "").replace(/\$/g, "");

    let checkValuesAreFilled;
    if(this.state.isHousingPaymentShow){
      checkValuesAreFilled = this.annualIncomeVal > 0 && sourceOfIncomeVal.length > 0 && residenceStatusVal.length > 0 && this.housingPaymentVal > 0
          && this.hasValidLoanAmountAndPurpose(loanPurpose);
    } else{
      checkValuesAreFilled = this.annualIncomeVal>0 && sourceOfIncomeVal.length >0 && residenceStatusVal.length> 0
        && this.hasValidLoanAmountAndPurpose(loanPurpose);
    }
    if (this.doesNotHaveLoanAmountInRange()) {
      this.setState({
        isButtonDisabled: !checkValuesAreFilled,
        loanAmountErrorMessage: 'Please enter a valid loan amount'
      });
    } else {
      this.setState({
        isButtonDisabled: !checkValuesAreFilled,
        loanAmountErrorMessage: ' '
      });
    }
  }

  doesNotHaveLoanAmountInRange() {
    return (typeof (this.loanAmountVal) !== "undefined" && this.loanAmountVal != null && this.loanAmountVal.length > 0)
        && ((+this.loanAmountVal < +this.props.customerInformation.displayMinAmount)
            || (+this.loanAmountVal > +this.props.customerInformation.displayMaxAmount));
  }

  hasValidLoanAmountAndPurpose(loanPurpose) {
    return (+this.loanAmountVal >= +this.props.customerInformation.displayMinAmount)
        && (+this.loanAmountVal <= +this.props.customerInformation.displayMaxAmount)
        && loanPurpose.length > 0;
  }

  onChange = (val, type) => {
    let isHousingPayment = (val === "Rent" || val === "Other") && type===2;
    if(!isHousingPayment){
      this.setState({ housingPaymentVal: "" });
    }
    this.setState({ isHousingPaymentShow: isHousingPayment });
  }

  handleInputChange(val, type){
    let statChangeObj={};
    switch(type){
    case 0:
      statChangeObj={ annualIncomeVal: val };
      break;
    case 1:
      statChangeObj={ sourceOfIncomeVal: val };
      break;
    case 2:
      statChangeObj={ residenceStatusVal: val };
      break;
    case 3:
      statChangeObj={ housingPaymentVal: val };
      break;
    case 4:
      statChangeObj={ loanAmountVal: val };
      break;
    case 5:
      statChangeObj={ loanPurpose: val };
    }

    this.setState(statChangeObj, ()=>{
      this.handleButtonDisable();
    });
  }

  handleLoanPurposeEmptyCheck() {
    if(this.state.loanAmountVal===null || this.state.loanAmountVal==='') {
      this.setState({
        loanAmountErrorMessage: 'Please enter a valid loan amount'
      });
    } else if(this.doesNotHaveLoanAmountInRange()) {
      this.setState({
        loanAmountErrorMessage: 'Please enter a valid loan amount'
      });
    } else {
      this.setState({
        loanAmountErrorMessage: ' '
      });
    }
  }

  handleContinueClick(e){
    e.preventDefault();
    this.props.saveCustomerInformation({
      grossAnnualIncomeInfo: this.state.annualIncomeVal.toString().replace(/,/g, "").replace(/\$/g, ""),
      sourceOfIncomeInfo: this.state.sourceOfIncomeVal,
      residenceStatusInfo: this.state.residenceStatusVal,
      housingPaymentInfo: this.state.housingPaymentVal.toString().replace(/,/g, "").replace(/\$/g, ""),
      yearsAtCurrentResidence: null,
      loanAmountInfo: this.state.loanAmountVal.toString().replace(/,/g, "").replace(/\$/g, ""),
      loanPurposeInfo: this.state.loanPurpose
    }, this.offerFinalDecision);
  }
  offerFinalDecision=(offerStatus)=>{
    let URL = null;
    if(offerStatus === "APPROVED"){
      URL = '/clapply/action/customizeOffer/loanInformation';
    }else if(offerStatus === "DECLINED" || offerStatus === "DECLINED_103"){
      URL = '/clapply/action/customizeOffer/declineOffer';
    }
    else{
      location.reload();
    }
    if(URL){
      this.props.history.push(URL);
    }
  }
  render() {
    const { grossIncome, sourceOfIncome, residenceStatus, housingPayment, crossSellLoanPurpose } = LoanInfoConstants.fields;
    const { isButtonDisabled } = this.state;
    const isHeaderShow=isMobileNativeApp()||getHeaderStatus(this.props.customerInformation.channelSource);
    let textAlign = isHeaderShow?"text-left":"text-center";
    return (
      <div className="row loanCustomerInfo">
        <div className="col col-sm-7 col-md-7 col-lg-7 mx-auto">
          <h4 className={`loan-info-heading standard-blue ${textAlign}`}>{LoanInfoConstants.heading}</h4>
          <div className="loan-info-body-wrapper">
            <InputLabel label={`Desired Loan Amount (${moneyFormatter.format('USD', this.state.displayMinAmount, 0)} - ${moneyFormatter.format('USD', this.state.displayMaxAmount, 0)})`}
              required={true}
              tabIndex="0"
              tooltip={"Desired Loan Amount"}/>
            <CurrencyInput id="desired-loan-amount"
              tabIndex="0"
              maxLength={6} //Max 5 digit allowed for gross income field, number is 6 considering comma's in currency
              size={5}
              copyPaste={true}
              inputValue={this.state.loanAmountVal}
              outputValue={e=>this.handleInputChange(e, 4)}
              onBlur={e=>this.handleLoanPurposeEmptyCheck()}
              placeholder="Enter your desired loan amount" />
            {this.state.loanAmountErrorMessage !== ' ' && <p className="loan-error-msg">{this.state.loanAmountErrorMessage}</p>}
            <div className="mb-4"></div>
            <InputLabel label={"Loan Purpose"}
              tabIndex="0" required={true}
              tooltip={"Loan Purpose"}/>
            <DropDown options={crossSellLoanPurpose.options}
              tabIndex="0"
              inputValue={this.state.selectedLoanPurpose}
              selectedOption={e=>this.handleInputChange(crossSellLoanPurpose.values[crossSellLoanPurpose.options.indexOf(e)], 5)}
              bodyId="loanPurposeBody"/>
            <InputLabel required={true} label={grossIncome.label} tooltip={grossIncome.tooltip} tabIndex="0" />
            <CurrencyInput id="gross-annual-income-input"
              tabIndex="0"
              maxLength={8} //Max 7 digit allowed for gross income field, number is 8 considering comma's in currency
              inputValue={this.state.annualIncomeVal}
              outputValue={e=>this.handleInputChange(e, 0)}
              placeholder="Enter your gross annual income" />
            <p className="cust-info-text cust-info-color">Please provide your total annual gross income.
              Gross annual income may include wages,
              retirement income, investments, etc. If you are
              under 21 include only your independent sources
              of income. You don't need to include alimony,
              child support, or separate maintenance income if
              you don't want us to consider it a basis for repayment.</p>
            <InputLabel label={sourceOfIncome.label}
              required={true}
              tabIndex="0"
              tooltip={sourceOfIncome.tooltip} />
            <DropDown options={sourceOfIncome.options}
              tabIndex="0"
              inputValue={this.state.sourceOfIncomeVal}
              selectedOption={e=>this.handleInputChange(e, 1)}
              bodyId="sourceOdIncomeBody"/>

            <InputLabel label={residenceStatus.label}
              required={true}
              tabIndex="0"
              tooltip={residenceStatus.tooltip} />
            <DropDown options={residenceStatus.options}
              tabIndex="0"
              inputValue={this.state.residenceStatusVal}
              selectedOption={e=>{ this.handleInputChange(e, 2); this.onChange(e, 2); }}
              bodyId="residenceStatusBody"/>
            {this.state.isHousingPaymentShow?
              <div>
                <InputLabel label={housingPayment.label}
                  required={true}
                  tabIndex="0"
                  tooltip={housingPayment.tooltip} />
                <CurrencyInput id="monthly-housing-payment-input"
                  tabIndex="0"
                  maxLength={8} //Max 7 digit allowed for monthly housing payment field, number is 8 considering comma's in currency
                  inputValue={this.state.housingPaymentVal}
                  outputValue={e=>this.handleInputChange(e, 3)}
                  placeholder="Enter your monthly housing payment" />
              </div>
              :null
            }
          </div>
        </div>
        <div className="col-md-12 col-xs-12">
          <div className="loan-info-btn-wrapper">
            <p className="display-text-small font-weight-400 continue-consent">
              By clicking continue, I authorize Barclays to obtain my credit report.
            </p>
            <button className={`loan-info-btn button-override-color ${isButtonDisabled?'loan-info-btn-disabled':''}`}
              id="continueButtonRef"
              disabled={isButtonDisabled}
              tabIndex="0"
              aria-label="click to continue to the next page"
              data-track="custom-links"
              onClick={this.handleContinueClick}>Continue</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customerInformation: getOfferPreFilledData(state)
});

const mapDispatchToProps = { saveCustomerInformation: saveCustomerInformation, fetchActiveLoans: fetchActiveLoans, fetchExternalAccounts: fetchExternalAccounts };

export default connect(mapStateToProps, mapDispatchToProps)(LoanCustomerInformation);
